export default __webpack_public_path__ + "static/media/connect-illustration.e917524b.svg";